import { useLayoutEffect, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import { syncAutoScalingState } from 'src/common/utils/autoScaling';
import { autoScalingEnabledAtom } from '../../atoms/ui/autoScaling';

export const AutoScalingWrapper = ({ children }: PropsWithChildren) => {
  const isAutoScalingEnabled = useAtomValue(autoScalingEnabledAtom);

  useLayoutEffect(() => {
    syncAutoScalingState(!isAutoScalingEnabled);
    globalThis.dispatchEvent(new Event('resize'));

    return () => syncAutoScalingState(false);
  }, [isAutoScalingEnabled]);

  return children;
};
